import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { API_URL } from "../../../config";

const formatDate = (value) => {
  if (!value) return "NA";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleString();
};

const getAddedBy = (entry) => {
  return entry.transaction_id && String(entry.transaction_id).startsWith("ADMIN-")
    ? "Admin"
    : "Distributor";
};

const TABS = [
  { key: "module", label: "Modules", endpoint: "module-txn" },
  { key: "sensor", label: "Sensors", endpoint: "sensor-txn" },
  { key: "warranty", label: "Warranty", endpoint: "warranty-txn" },
];

const TxnHistoryModal = ({ historyModal, setHistoryModal, distributorId }) => {
  const [activeTab, setActiveTab] = useState("module");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [history, setHistory] = useState({ module: [], sensor: [], warranty: [] });

  useEffect(() => {
    if (!historyModal || !distributorId) return;

    const fetchHistory = async () => {
      setLoading(true);
      setError("");
      try {
        const token = localStorage.getItem("accessToken");
        const headers = { "x-access-token": token };

        const responses = await Promise.all(
          TABS.map((tab) =>
            fetch(`${API_URL}/${tab.endpoint}/history/${distributorId}`, { headers }).then((r) =>
              r.json()
            )
          )
        );

        const next = {};
        TABS.forEach((tab, index) => {
          next[tab.key] = responses[index]?.data || [];
        });

        setHistory(next);
      } catch (err) {
        setError("Failed to load history");
      } finally {
        setLoading(false);
      }
    };

    setActiveTab("module");
    fetchHistory();
  }, [historyModal, distributorId]);

  const activeEntries = history[activeTab] || [];

  return (
    <Modal
      isOpen={historyModal}
      toggle={() => setHistoryModal(false)}
      className="connect-box"
      size="lg"
      centered={true}
    >
      <ModalHeader className="text-white" toggle={() => setHistoryModal(false)}>
        <span className="ml-1 roititle text-white">Txn History</span>
      </ModalHeader>

      <ModalBody>
        <Nav tabs className="txn-history-tabs">
          {TABS.map((tab) => (
            <NavItem key={tab.key}>
              <NavLink
                className={activeTab === tab.key ? "active" : ""}
                onClick={() => setActiveTab(tab.key)}
                style={{ cursor: "pointer" }}
              >
                {tab.label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        <TabContent activeTab={activeTab} className="pt-3">
          {TABS.map((tab) => (
            <TabPane tabId={tab.key} key={tab.key}>
              {loading ? (
                <div className="text-center py-4">
                  <i className="fa fa-spinner fa-spin fa-2x" style={{ color: "rgb(77, 0, 77)" }}></i>
                </div>
              ) : error ? (
                <div style={{ color: "red", fontSize: "13px" }}>{error}</div>
              ) : activeEntries.length === 0 ? (
                <p className="font14 text-center">No history found</p>
              ) : (
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <table className="distributors-table" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>Quantity</th>
                        <th>Added By</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activeEntries.map((entry, index) => (
                        <tr key={entry.id ?? index}>
                          <td>{entry.available ?? entry.quantity ?? "NA"}</td>
                          <td>{getAddedBy(entry)}</td>
                          <td>{formatDate(entry.created_at || entry.date)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </TabPane>
          ))}
        </TabContent>
      </ModalBody>
    </Modal>
  );
};

export default TxnHistoryModal;
